<template>
  <div
    v-if="element.type == 'Narrative trigger'"
    class="flex flex-row justify-between mb-4 cursor-pointer p-4"
  >
    <div class="w-1/3 bg-gray-700 h-3 mt-2"></div>
    <span class="text-gray-500 font-semibold text-md"
      >{{ element.rank + 1 }}. Trigger</span
    >
    <div class="w-1/3 bg-gray-700 h-3 mt-2"></div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="h-6 text-red-500 hover:text-red-700"
      aria-label="Delete element"
      @click="deleteElement(element)"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5
        7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  </div>
  <div
    class="p-4 mb-6 border-gray-200 border shadow-md rounded-md
    hover:bg-gray-50 cursor-pointer"
    v-else
  >
    <!-- :class="{ trigger: isTrigger }" -->
    <div class="flex flex-row justify-between">
      <h1 class="text-md font-semibold text-gray-500">
        {{ element.rank + 1 }}. {{ element.type }}
      </h1>
      <div class="flex flex-row">
        <!-- EDIT ICON -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="h-6 text-gray-500 hover:text-blue-500"
          aria-label="Edit element"
          @click="editElement"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0
            002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828
            15H9v-2.828l8.586-8.586z"
          />
        </svg>

        <!-- GARBAGE CAN ICON -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="h-6 text-red-500 hover:text-red-700"
          aria-label="Delete element"
          @click="deleteElement(element)"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0
            01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1
            1v3M4 7h16"
          />
        </svg>
      </div>
    </div>

    <span class="text-gray-500" v-if="element.type == 'Title'">
      {{ element.title }} by {{ element.author }} {{ element.id }}
    </span>

    <div
      class="mt-2 text-gray-500 border border-gray-100 h-8 w-full rounded-md"
      v-if="element.type == 'Background color'"
      :style="{ backgroundColor: element.backgroundColor }"
    ></div>

    <span v-if="element.type == 'Text'" class="text-gray-400">
      <span class="text-gray-500">{{ element.text.slice(1,150) }} ...</span>
    </span>

    <span v-if="element.type == 'Tick'" class="text-gray-400">
      <span v-if="element.number > 1" class="text-gray-500"
        >{{ humanize(element.number) }} ticks</span
      >
      <span v-else class="text-gray-500">{{ element.number }} tick</span>
    </span>

    <div
      v-if="element.type == 'Background image/video'"
      class="flex flex-row justify-around bg-gray-100 rounded-md p-4"
    >
      <img :src="element.url" class="h-40 bg-cover bg-center rounded-md mt-2" />
    </div>

    <div
      v-if="element.type == 'Image/video'"
      class="flex flex-row justify-around bg-gray-100 rounded-md p-4"
    >
      <img :src="element.url" class="h-40 bg-cover bg-center rounded-md mt-2" />
    </div>
     <div
      v-if="element.type == 'Audio'"
      class="flex flex-row justify-around bg-gray-100 rounded-md p-4"
    >
      <audio :src="element.url" class="h-40 bg-cover bg-center rounded-md mt-2" />
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"
import { reportError, humanize, titleCase, stripHash } from "@/utils.js";

export default {
  components: {},

  props: ["element"],

  data() {
    return {};
  },

  watch: {},

  methods: {
    humanize(num) {
      return titleCase(humanize(num));
    },

    editElement(element) {
      this.$emit("edit-element", this.element);
    },

    deleteElement(element) {
      stripHash(element)
      this.$samsa
        .deleteElement(element)
        .then((res) => {
          this.$store.commit("setNarrative", res.data);
        })
        .catch((err) => {
          reportError(err);
        });
    },
  },

  computed: {
    isTrigger() {
      return this.element.type == "Narrative trigger";
    },
  },

  mounted() {},
};
</script>

<style>
.trigger {
  background-color: #dbeafe !important;
  border: 2px solid #3f3f3f !important;
}
</style>
